import { createTheme } from "@mui/material";


declare module '@mui/material/styles' {
    interface Palette {
        darkBackground?: Palette['primary'];
        primaryAccent?: Palette['primary'];
        secondaryAccent?: Palette['primary'];
    }
    interface PaletteOptions {
        darkBackground?: PaletteOptions['primary'];
        primaryAccent?: PaletteOptions['primary'];
        secondaryAccent?: PaletteOptions['primary'];
    }
}

export const ThemeDetails = createTheme({
    /* COLORES PRINCIPALES */
    palette: {
        mode: 'dark',
        primary: {
            main: "#F4D35E",
            light: "#F7E08D",
            dark: "#F2CB40",
        },
        secondary: {
            main: "#574375",
            light: "#6A528E",
            dark: "#43345B",
        },
        primaryAccent: {
            main: "#EE964B",
            light: "#FFB77A",
            dark: "#F4D35E",
        },
        secondaryAccent: {
            main: "#00a884",
            light: "#FF7854",
            dark: "#C0412B",
        },
        background: {
            default: '#0E0A15',
            paper: '#171023',
        },
        darkBackground: {
            main: "#171023",
            light: "#221835",
            dark: "#0E0A15",
        },
        text: {
            primary: '#FAFAFA',
            secondary: '#909090',
        },

        success: {
            main: "#3DDC97",
        },
        error: {
            main: "#CE3197",
        },
        warning: {
            main: "#D57ED7",
        },
    },


    components: {
        MuiPaper: {
            styleOverrides: {
              root: {
                backgroundImage: 'none',  // Elimina el background-image predeterminado
              },
            },
          },
        MuiContainer: {
            defaultProps: {
                maxWidth: 'xl', // Establece el ancho máximo predeterminado para Container
            },
        },
    },

});